const channelTypes = {
  1: 'SHOPIFY',
  2: 'WOOCOMMERCE',
  3: 'AMAZON',
  4: 'API2CART',
  5: 'HUBSPOT',
  6: 'ECARTAPI',
  7: 'TRACKSTAR',
};

const channelTypeLabels = {
  end_to_end_channel: 'End to End Channel',
  fulfillment_channel: 'Fulfillment Channel',
  sales_channel: 'Sales Channel',
};

export const ChannelConfig = {
  channelTypes,
  channelTypeLabels,
};
